// Libraries
import { ReactNode, MouseEventHandler } from 'react';

// Styles
import styles from './IconButton.module.css';

/**
 * @function IconButton
 * Clickable user interface element with icon
 *
 * @example
 *   <IconButton type={'button'} className={''} onClick={() => false}></IconButton>
 */
function IconButton({
    type,
    className,
    onClick = () => false,
    children = <></>,
}: IconButtonProps): JSX.Element {
    const fullClassName = className
        ? `${styles.button} ${styles[className]}`
        : styles.button;
    return (
        <button
            type={type}
            className={fullClassName}
            onClick={(e) => onClick(e)}
        >
            {children}
        </button>
    );
}

/**
 * @interface IconButtonProps
 * Describes the properties required for the IconButton component
 *
 * @property {string} type HTML type attribute
 * @property {string} className Additional class name to call
 * @property {function} onClick Return function to call when clicked
 * @property {ReactNode} children FontAwesomeIcon to display
 */
export interface IconButtonProps {
    type: 'button' | 'submit' | 'reset';
    className?: string;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    children?: ReactNode;
}

// Exports
export default IconButton;
